// FUNCTION TO REDIRECT TO HOME PAGE
export function redirectPage() {
  const redirectTag = $('.redirect-countdown');
  if (!redirectTag.length) return;
  
  let count = 5;
  const intervalID = setInterval(() => {
    redirectTag.text(`${count}s`);
    (count > 0)
      ? count-- 
      : (function() {
          window.location.assign("/");
          clearInterval(intervalID)
        })();
  }, 1000);
}